import { connect } from "knockout-store";
import ko from "knockout";
import { getContentByParagraphID } from "../../utils/content";

function metaboxViewModel(params) {
  const vm = {};

  params.currentParagraphID.subscribe(function (value) {
    if (value !== undefined) {
      const metaData = getContentByParagraphID(
        value,
        "meta_data",
        params.storylineData()
      );
      vm.paragraphMetaData({
        date: metaData?.date ? metaData.date : "—",
        time: metaData?.time ? metaData.time : "—",
        locations: metaData?.locations ? metaData.locations : "—",
      });
    }
  });
  vm.paragraphMetaData = ko.observable("");

  return vm;
}

function mapStateToParams({ route, currentParagraphID, storylineData }) {
  return { route, currentParagraphID, storylineData };
}

export default connect(mapStateToParams)(metaboxViewModel);
